export class ChangeSubcriptionPlan {
    client_acct_id: string;
    plan_no:string;
    schedule_no:string;
    existing_master_plan_instance_no : string;
}